export type InstanciaTarefa = {
    id_kanban_instancia_tarefa: number;
    nome_tarefa: string;
    tempo_execucao_horas: number;
    tempo_definido_usuario?: number;
    ordem_tarefa: number;
    status: string;
    inicio_execucao?: string | null;
    justificativa_atraso?: string | null;
    atrasado_em?: string | null;
    id_kanban_modulo?: number;
    nome_modulo?: string;
};

export type KanbanInstancia = {
    id_kanban_instancia: number;
    id_kanban_grupo: number;
    id_kanban_modulo: number;
    nome_instancia: string;
    nome_grupo?: string | null;
    id_usuario_responsavel?: number | null;
    nome_responsavel?: string | null;
    justificativa_retorno?: string | null;
    retornado_em?: string | null;
    entrada_modulo_em?: string | null;
    dias_restantes_modulo?: number | null;
    tarefas: InstanciaTarefa[];
};

/**
 * Calcula os dias restantes de prazo no módulo atual.
 * Base: saldo capturado ao entrar no módulo - dias corridos desde a entrada.
 * Retorna null se não há prazo configurado para esta instância/módulo.
 */
export function calcularDiasPrazo(inst: KanbanInstancia): number | null {
    if (inst.dias_restantes_modulo === null || inst.dias_restantes_modulo === undefined) return null;
    if (!inst.entrada_modulo_em) return Number(inst.dias_restantes_modulo);
    const entrada = new Date(inst.entrada_modulo_em).getTime();
    const agora = Date.now();
    const diasDecorridos = Math.floor((agora - entrada) / 86400000);
    return Number(inst.dias_restantes_modulo) - diasDecorridos;
}

export function corPrazo(dias: number): { bg: string; border: string; text: string } {
    if (dias < 0) return { bg: "#ffebee", border: "#ef5350", text: "#c62828" };
    if (dias <= 3) return { bg: "#fff8e1", border: "#ffc107", text: "#e65100" };
    return { bg: "#e8f5e9", border: "#81c784", text: "#2e7d32" };
}

export const STATUS_CONFIG: Record<string, { label: string; color: string }> = {
    aguardando: { label: "Aguardando", color: "#424242" },
    em_execucao: { label: "Em execução", color: "#1565c0" },
    aguardando_resposta: { label: "Aguardando resposta", color: "#f9a825" },
    finalizado: { label: "Finalizado", color: "#2e7d32" },
};

export const STATUS_OPTIONS = Object.keys(STATUS_CONFIG);

export function getStatusConfig(status: string) {
    return STATUS_CONFIG[status] || STATUS_CONFIG.aguardando;
}

export function calcularTempoRestante(
    tarefa: InstanciaTarefa,
    now: number
): { texto: string; expirado: boolean } | null {
    if (tarefa.status !== "em_execucao" || !tarefa.inicio_execucao || Number(tarefa.tempo_execucao_horas) <= 0) return null;
    const inicio = new Date(tarefa.inicio_execucao).getTime();
    const limiteMs = tarefa.tempo_execucao_horas * 3600000;
    const fimMs = inicio + limiteMs;
    const diffMs = fimMs - now;
    const expirado = diffMs <= 0;
    const absDiff = Math.abs(diffMs);
    const totalSeg = Math.floor(absDiff / 1000);
    const h = Math.floor(totalSeg / 3600);
    const m = Math.floor((totalSeg % 3600) / 60);
    const s = totalSeg % 60;
    const pad = (n: number) => String(n).padStart(2, "0");
    const texto = expirado ? `-${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
    return { texto, expirado };
}

export function tarefaTemTimer(tarefa: InstanciaTarefa) {
    return (
        tarefa.status === "em_execucao" &&
        !!tarefa.inicio_execucao &&
        Number(tarefa.tempo_execucao_horas) > 0
    );
}
